/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CreateExploreFromWarehouseTableMutationVariables = Types.Exact<{
  dataSourceTableId: Types.Scalars["DataSourceTableId"]["input"];
}>;

export type CreateExploreFromWarehouseTableMutation = {
  readonly __typename: "Mutation";
  readonly createExploreFromData: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
  };
};

export type CreateExploreFromSemanticDatasetMutationVariables = Types.Exact<{
  semanticDatasetId: Types.Scalars["SemanticDatasetId"]["input"];
  semanticProjectVersionString: Types.InputMaybe<
    Types.Scalars["SemanticProjectVersionString"]["input"]
  >;
  initialMeasureName: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  initialDimensionName: Types.InputMaybe<Types.Scalars["String"]["input"]>;
}>;

export type CreateExploreFromSemanticDatasetMutation = {
  readonly __typename: "Mutation";
  readonly createExploreFromData: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
  };
};

export type CreateExploreFromSemanticViewMutationVariables = Types.Exact<{
  semanticViewId: Types.Scalars["SemanticViewId"]["input"];
  semanticProjectVersionString: Types.InputMaybe<
    Types.Scalars["SemanticProjectVersionString"]["input"]
  >;
  initialMeasureName: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  initialDimensionName: Types.InputMaybe<Types.Scalars["String"]["input"]>;
}>;

export type CreateExploreFromSemanticViewMutation = {
  readonly __typename: "Mutation";
  readonly createExploreFromData: {
    readonly __typename: "Hex";
    readonly id: c.HexId;
  };
};

export const CreateExploreFromWarehouseTableDocument = /*#__PURE__*/ gql`
  mutation CreateExploreFromWarehouseTable(
    $dataSourceTableId: DataSourceTableId!
  ) {
    createExploreFromData(dataSourceTableId: $dataSourceTableId) {
      id
    }
  }
`;
export type CreateExploreFromWarehouseTableMutationFn = Apollo.MutationFunction<
  CreateExploreFromWarehouseTableMutation,
  CreateExploreFromWarehouseTableMutationVariables
>;

/**
 * __useCreateExploreFromWarehouseTableMutation__
 *
 * To run a mutation, you first call `useCreateExploreFromWarehouseTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExploreFromWarehouseTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExploreFromWarehouseTableMutation, { data, loading, error }] = useCreateExploreFromWarehouseTableMutation({
 *   variables: {
 *      dataSourceTableId: // value for 'dataSourceTableId'
 *   },
 * });
 */
export function useCreateExploreFromWarehouseTableMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateExploreFromWarehouseTableMutation,
    CreateExploreFromWarehouseTableMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateExploreFromWarehouseTableMutation,
    CreateExploreFromWarehouseTableMutationVariables
  >(CreateExploreFromWarehouseTableDocument, options);
}
export type CreateExploreFromWarehouseTableMutationHookResult = ReturnType<
  typeof useCreateExploreFromWarehouseTableMutation
>;
export type CreateExploreFromWarehouseTableMutationResult =
  Apollo.MutationResult<CreateExploreFromWarehouseTableMutation>;
export type CreateExploreFromWarehouseTableMutationOptions =
  Apollo.BaseMutationOptions<
    CreateExploreFromWarehouseTableMutation,
    CreateExploreFromWarehouseTableMutationVariables
  >;
export const CreateExploreFromSemanticDatasetDocument = /*#__PURE__*/ gql`
  mutation CreateExploreFromSemanticDataset(
    $semanticDatasetId: SemanticDatasetId!
    $semanticProjectVersionString: SemanticProjectVersionString
    $initialMeasureName: String
    $initialDimensionName: String
  ) {
    createExploreFromData(
      semanticDatasetId: $semanticDatasetId
      semanticProjectVersionString: $semanticProjectVersionString
      initialMeasureName: $initialMeasureName
      initialDimensionName: $initialDimensionName
    ) {
      id
    }
  }
`;
export type CreateExploreFromSemanticDatasetMutationFn =
  Apollo.MutationFunction<
    CreateExploreFromSemanticDatasetMutation,
    CreateExploreFromSemanticDatasetMutationVariables
  >;

/**
 * __useCreateExploreFromSemanticDatasetMutation__
 *
 * To run a mutation, you first call `useCreateExploreFromSemanticDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExploreFromSemanticDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExploreFromSemanticDatasetMutation, { data, loading, error }] = useCreateExploreFromSemanticDatasetMutation({
 *   variables: {
 *      semanticDatasetId: // value for 'semanticDatasetId'
 *      semanticProjectVersionString: // value for 'semanticProjectVersionString'
 *      initialMeasureName: // value for 'initialMeasureName'
 *      initialDimensionName: // value for 'initialDimensionName'
 *   },
 * });
 */
export function useCreateExploreFromSemanticDatasetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateExploreFromSemanticDatasetMutation,
    CreateExploreFromSemanticDatasetMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateExploreFromSemanticDatasetMutation,
    CreateExploreFromSemanticDatasetMutationVariables
  >(CreateExploreFromSemanticDatasetDocument, options);
}
export type CreateExploreFromSemanticDatasetMutationHookResult = ReturnType<
  typeof useCreateExploreFromSemanticDatasetMutation
>;
export type CreateExploreFromSemanticDatasetMutationResult =
  Apollo.MutationResult<CreateExploreFromSemanticDatasetMutation>;
export type CreateExploreFromSemanticDatasetMutationOptions =
  Apollo.BaseMutationOptions<
    CreateExploreFromSemanticDatasetMutation,
    CreateExploreFromSemanticDatasetMutationVariables
  >;
export const CreateExploreFromSemanticViewDocument = /*#__PURE__*/ gql`
  mutation CreateExploreFromSemanticView(
    $semanticViewId: SemanticViewId!
    $semanticProjectVersionString: SemanticProjectVersionString
    $initialMeasureName: String
    $initialDimensionName: String
  ) {
    createExploreFromData(
      semanticViewId: $semanticViewId
      semanticProjectVersionString: $semanticProjectVersionString
      initialMeasureName: $initialMeasureName
      initialDimensionName: $initialDimensionName
    ) {
      id
    }
  }
`;
export type CreateExploreFromSemanticViewMutationFn = Apollo.MutationFunction<
  CreateExploreFromSemanticViewMutation,
  CreateExploreFromSemanticViewMutationVariables
>;

/**
 * __useCreateExploreFromSemanticViewMutation__
 *
 * To run a mutation, you first call `useCreateExploreFromSemanticViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExploreFromSemanticViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExploreFromSemanticViewMutation, { data, loading, error }] = useCreateExploreFromSemanticViewMutation({
 *   variables: {
 *      semanticViewId: // value for 'semanticViewId'
 *      semanticProjectVersionString: // value for 'semanticProjectVersionString'
 *      initialMeasureName: // value for 'initialMeasureName'
 *      initialDimensionName: // value for 'initialDimensionName'
 *   },
 * });
 */
export function useCreateExploreFromSemanticViewMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateExploreFromSemanticViewMutation,
    CreateExploreFromSemanticViewMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateExploreFromSemanticViewMutation,
    CreateExploreFromSemanticViewMutationVariables
  >(CreateExploreFromSemanticViewDocument, options);
}
export type CreateExploreFromSemanticViewMutationHookResult = ReturnType<
  typeof useCreateExploreFromSemanticViewMutation
>;
export type CreateExploreFromSemanticViewMutationResult =
  Apollo.MutationResult<CreateExploreFromSemanticViewMutation>;
export type CreateExploreFromSemanticViewMutationOptions =
  Apollo.BaseMutationOptions<
    CreateExploreFromSemanticViewMutation,
    CreateExploreFromSemanticViewMutationVariables
  >;
